export default "__VITE_ASSET__CHGPtk$6__"